import axios from "axios";
import translate from "./../translations";
import * as sharedConstants from "./../shared/shared-constants";
import * as VueGoogleMaps from "vue2-google-maps";
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

import Vue from "vue";
import "livewire-vue";
import Vuex from "vuex";
import store from "../store/index";
import Cookies from "js-cookie";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import { ScreenUtil } from "../utilities/screen";
import config from "../constants";

Vue.use(Vuex);
Vue.prototype.$sharedConstants = sharedConstants;

Vue.config.productionTip = false;

window.Vue = Vue; //this is important! Do not use require('vue')

axios.defaults.baseURL = "/api/";
Vue.prototype.$http = axios;

if (process.env.MIX_ENV == "staging" || process.env.MIX_ENV == "production") {
  Vue.prototype.$storageUrl = process.env.MIX_STORAGE_URL;
} else {
  Vue.prototype.$storageUrl = "/storage/";
}
Vue.prototype.$cookies = Cookies;
Vue.prototype.$screen = ScreenUtil;
Vue.prototype.$config = config;

Vue.use(VueGoogleMaps, {
  load: {
    key:
      process.env.MIX_GOOGLE_MAPS_KEY !== undefined
        ? process.env.MIX_GOOGLE_MAPS_KEY
        : "undefined",
    libraries: "places", // This is required if you use the Autocomplete plugin
  },
  installComponents: true,
});

Vue.component("GmapCluster", GmapCluster);

Vue.mixin({
  methods: {
    __(...args) {
      return translate(...args);
    },
  },
});

Vue.directive("click-outside", {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
});

Vue.component("example-component", require("./ExampleComponent.vue").default);

Vue.component("old-product-list", () =>
  import("./colored-product/old-product-list.vue")
);

Vue.component("colored-products-list", () =>
  import("./custom-colored-product/lists/colored-products-list.vue")
);

// Vue.component("custom-product-list", () =>
//   import("./custom-colored-product/lists/custom-product-list.vue")
// );

Vue.component("custom-product-countdown", () =>
  import("./custom-colored-product/card/custom-product-countdown.vue")
);

Vue.component("custom-product-category-filters", () =>
  import(
    "./custom-colored-product/category-filters/custom-product-category-filters.vue"
  )
);

Vue.component("category-tree-for-trademark", () =>
  import(
    "./custom-colored-product/category-filters/category-tree-for-trademark.vue"
  )
);

Vue.component("category-name", () =>
  import("./colored-product/category-name.vue")
);

Vue.component("search-product-list", () =>
  import("./colored-product/search-product-list.vue")
);

Vue.component("related-products", () =>
  import("./colored-product/related-products.vue")
);

Vue.component(
  "product-card",
  require("./colored-product/card/product-card.vue").default
);

Vue.component("wishlist-product-card", () =>
  import("./colored-product/card/wishlist-product-card.vue")
);

Vue.component("search-product-card", () =>
  import("./colored-product/card/search-product-card.vue")
);

Vue.component("watchdog-items-product-list", () =>
  import("./colored-product/watchdog-items-product-list.vue")
);

Vue.component("watchdog-item-product-card", () =>
  import("./colored-product/card/watchdog-item-product-card.vue")
);

Vue.component("modal-content", () => import("./modal/modal-content.vue"));

Vue.component("modal-static", () =>
  import("./modal/modal-types/modal-static.vue")
);

Vue.component("modal-size", () => import("./modal/modal-types/modal-size.vue"));

Vue.component("modal-variant-details", () =>
  import("./modal/modal-types/modal-variant-details.vue")
);

Vue.component("modal-with-dynamic-content", () =>
  import("./modal/modal-types/modal-with-dynamic-content.vue")
);

Vue.component("modal-product-availability", () =>
  import("./modal/modal-types/modal-product-availability.vue")
);

Vue.component("modal-watchdog", () =>
  import("./modal/modal-types/modal-watchdog.vue")
);

Vue.component("modal-wishlist", () =>
  import("./modal/modal-types/modal-wishlist.vue")
);

Vue.component("wishlist-span", require("./wishlist-span.vue").default);

Vue.component("anchor-title", require("./anchor-title.vue").default);

Vue.component("cart-item-order", require("./cart-item-order.vue").default);

Vue.component("button-title", require("./button-title.vue").default);

Vue.component("main-search", require("./main-search.vue").default);
Vue.component(
  "custom-colored-product-quick-search-bar",
  require("./search/search-bar.vue").default
);

Vue.component("search-result", () =>
  import("./colored-product/search-result.vue")
);

Vue.component("list-products", () =>
  import("./colored-product/list-products.vue")
);

Vue.component("elastic-search-search-result", () =>
  import("./colored-product/elastic-search-search-result.vue")
);

Vue.component("elastic-search-results", () =>
  import("./custom-colored-product/lists/search/search-results.vue")
);

Vue.component("empty-category-list", () =>
  import("./custom-colored-product/lists/empty-category-list.vue")
);

Vue.component("last-visited-colored-products-list", () =>
  import(
    "./custom-colored-product/lists/last-visited-colored-products-list.vue"
  )
);

Vue.component("modal-wishlist-email", () =>
  import("./modal/modal-wishlist-email.vue")
);

Vue.component("modal-cookies", () => import("./modal/modal-cookies.vue"));
Vue.component("modal-language", () => import("./modal/modal-language.vue"));

Vue.component("spinner-gant", require("./spinner-gant.vue").default);
Vue.component("spinner-vermont", require("./spinner-vermont.vue").default);
Vue.component("loader", require("./loader.vue").default);

Vue.component("stores-map", () => import("./map/stores-map.vue"));
Vue.component("stores-map-info-window", () =>
  import("./map/stores-map-info-window.vue")
);

Vue.component(
  "product-list-pagination",
  require("./colored-product/product-list-pagination.vue").default
);
Vue.component(
  "elastic-product-list-pagination",
  require("./colored-product/elastic-product-list-pagination.vue").default
);
Vue.component(
  "colored-products-list-pagination",
  require("./custom-colored-product/paginations/colored-products-list-pagination.vue")
    .default
);

Vue.component(
  "product-list-exponea-event",
  require("./colored-product/product-list-exponea-event.vue").default
);

Vue.component(
  "product-list-datalayer-event",
  require("./colored-product/product-list-datalayer-event.vue").default
);

// Vue.component(
//   "product-list-subcategories",
//   require("./colored-product/product-list-subcategories.vue").default
// );

Vue.component(
  "colored-products-categories-list",
  require("./custom-colored-product/categories/colored-products-categories-list.vue")
    .default
);

Vue.component(
  "elastic-product-list-subcategories",
  require("./colored-product/elastic-product-list-subcategories.vue").default
);
Vue.component(
  "trademark-thats-not-all-btn",
  require("./colored-product/trademark-thats-not-all-btn.vue").default
);

Vue.component(
  "product-category-filters",
  require("./colored-product/product-category-filters/product-category-filters.vue")
    .default
);

Vue.component(
  "product-category-filter-main-item",
  require("./colored-product/product-category-filters/product-category-filter-main-item.vue")
    .default
);

Vue.component(
  "elastic-category-filter-main-item",
  require("./colored-product/product-category-filters/elastic-category-filter-main-item.vue")
    .default
);

Vue.component("product-category-filter-sub", () =>
  import(
    "./colored-product/product-category-filters/product-category-filter-sub.vue"
  )
);

Vue.component("elastic-product-category-filter-sub", () =>
  import(
    "./colored-product/product-category-filters/elastic-product-category-filter-sub.vue"
  )
);

Vue.component("product-category-filter-sub-item", () =>
  import(
    "./colored-product/product-category-filters/product-category-filter-sub-item.vue"
  )
);

Vue.component("elastic-product-category-filter-sub-item", () =>
  import(
    "./colored-product/product-category-filters/elastic-product-category-filter-sub-item.vue"
  )
);

Vue.component(
  "product-filters",
  require("./colored-product/product-filters/product-filters.vue").default
);

Vue.component(
  "elastic-product-filters",
  require("./colored-product/product-filters/elastic-product-filters.vue")
    .default
);

Vue.component(
  "product-filter",
  require("./colored-product/product-filters/product-filter.vue").default
);

Vue.component(
  "elastic-product-filter",
  require("./colored-product/product-filters/elastic-product-filter.vue")
    .default
);
Vue.component("product-active-filters", () =>
  import("./colored-product/product-filters/product-active-filters.vue")
);
Vue.component("elastic-product-active-filters", () =>
  import("./colored-product/product-filters/elastic-product-active-filters.vue")
);
Vue.component("product-filter-item", () =>
  import("./colored-product/product-filters/product-filter-item.vue")
);
Vue.component("elastic-product-filter-item", () =>
  import("./colored-product/product-filters/elastic-product-filter-item.vue")
);
Vue.component("elastic-product-active-filter", () =>
  import("./colored-product/product-filters/elastic-product-active-filter.vue")
);
Vue.component("product-active-filter", () =>
  import("./colored-product/product-filters/product-active-filter.vue")
);

Vue.component("product-filter-order-options", () =>
  import("./colored-product/product-filters/product-filter-order-options.vue")
);
Vue.component("product-filter-order-option", () =>
  import("./colored-product/product-filters/product-filter-order-option.vue")
);

Vue.component("delivery-and-shipping-page", () =>
  import("./order/delivery-and-shipping.vue")
);
Vue.component("delivery-method", () =>
  import("./order/order-selection-methods/delivery-method.vue")
);
Vue.component("payment-method", () =>
  import("./order/order-selection-methods/payment-method.vue")
);
Vue.component("order-personal-details-link", () =>
  import("./order/links/order-personal-details-link.vue")
);
Vue.component("delivery-footer", () =>
  import("./order/order-selection-methods/delivery-footer.vue")
);

Vue.component(
  "store-filters",
  require("./store/store-filters/store-filters.vue").default
);
Vue.component(
  "store-filter",
  require("./store/store-filters/store-filter.vue").default
);
Vue.component("store-filter-item", () =>
  import("./store/store-filters/store-filter-item.vue")
);

Vue.component("store-active-filters", () =>
  import("./store/store-filters/store-active-filters.vue")
);
Vue.component("store-active-filter", () =>
  import("./store/store-filters/store-active-filter.vue")
);

Vue.component("store-list", require("./store/store-list.vue").default);
Vue.component("store-card", require("./store/store-card.vue").default);

Vue.component("admin-helper", () => import("./admin-helper/admin-helper.vue"));
Vue.component("admin-helper-button", () =>
  import("./admin-helper/admin-helper-button.vue")
);
Vue.component("admin-helper-item", () =>
  import("./admin-helper/admin-helper-item.vue")
);
Vue.component("admin-helper-menu", () =>
  import("./admin-helper/admin-helper-menu.vue")
);
Vue.component("admin-helper-table", () =>
  import("./admin-helper/admin-helper-table.vue")
);
Vue.component("admin-helper-table-row", () =>
  import("./admin-helper/admin-helper-table-row.vue")
);
Vue.component("admin-helper-tree", () =>
  import("./admin-helper/admin-helper-tree.vue")
);

Vue.component(
  "shared-button",
  require("./shared-button/shared-button.vue").default
);
Vue.component(
  "shared-error",
  require("./shared-error/shared-error.vue").default
);
Vue.component(
  "shared-input-radio",
  require("./shared-input-radio/shared-input-radio.vue").default
);
Vue.component(
  "shared-lazy-image",
  require("./shared-lazy-image/shared-lazy-image.vue").default
);
Vue.component(
  "shared-select",
  require("./shared-select/shared-select.vue").default
);
Vue.component(
  "shared-switch",
  require("./shared-switch/shared-switch.vue").default
);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
if (process.env.MIX_ENV === "production") {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
} else {
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false;
}

const app = new Vue({
  store,
  el: "#app",
  data: {
    isOpen: false,
  },
});
